import {API} from '../../Services';
import moment from "moment-jalaali";

async function AccessTokenData(token){
    return API.get(`/payments/invoices-tokens/${token}`);
}

async function FactorData(factorId){
    let token =  localStorage.getItem('token');
    return API.get(`/payments/invoices/${factorId}`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function RateData(factorId){
    let token =  localStorage.getItem('token');
    return API.get(`/polls/merchant_poll/${factorId}`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function RateSend(factorId,reqObj){
    let token =  localStorage.getItem('token');
    return API.post(`/polls/merchant_poll/${factorId}`,reqObj,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

const ConvertToJalali = (date) =>{
    // console.log("Data : ",date)
    if(date){
        return  moment.utc(date.split('+')[0]).format('jYYYY-jMM-jDD HH:mm');
    }
    return ""
}

export {
    AccessTokenData,
    FactorData,
    ConvertToJalali,
    RateSend,
    RateData,
};
